import React, { useState } from 'react'
import { Modal, Button, TextArea, Banner } from '@ui'

const TEMPLATE = 'email,name,manager_email,team\nalice@company.com,Alice Chen,manager@company.com,Engineering'

export function BulkImportModal({ onClose, onSubmit }) {
  const [csv, setCsv] = useState('')
  const [loading, setLoading] = useState(false)
  const [result, setResult] = useState(null)
  const [error, setError] = useState(null)

  async function handleSubmit(e) {
    e.preventDefault()
    setLoading(true)
    setError(null)
    try {
      const res = await onSubmit(csv)
      setResult(res)
    } catch (err) {
      setError(err.message || 'Import failed.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal open onClose={onClose} title="Bulk import users" width="md">
      <p style={{ fontSize: 12, color: 'var(--text-secondary)', margin: 0 }}>
        Paste CSV below. Required column: <code>email</code>. Optional: <code>name</code>, <code>manager_email</code>, <code>team</code>.
      </p>
      {result ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-1)', fontSize: 13 }}>
          <div>✓ Invited: <strong>{result.invited}</strong></div>
          {result.skipped > 0 && <div>Skipped: {result.skipped}</div>}
          {result.errors?.length > 0 && (
            <div>Errors: {result.errors.map((e) => e.email).join(', ')}</div>
          )}
          <div className="modal__actions">
            <Button onClick={onClose}>Done</Button>
          </div>
        </div>
      ) : (
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
          {error ? <Banner tone="error">{error}</Banner> : null}
          <TextArea
            value={csv}
            onChange={(e) => setCsv(e.target.value)}
            placeholder={TEMPLATE}
            rows={8}
            // CSV alignment is easier to scan in monospace; this is the only
            // place we deviate from the single-family rule (design doc §3.1).
            style={{ resize: 'vertical', fontFamily: 'monospace', fontSize: 12 }}
          />
          <div className="modal__actions">
            <Button variant="secondary" onClick={onClose}>Cancel</Button>
            <Button
              type="submit"
              disabled={!csv.trim()}
              loading={loading}
              loadingLabel="Importing…"
            >
              Import
            </Button>
          </div>
        </form>
      )}
    </Modal>
  )
}
